<template>
    <ui-dropdown placement="bottom-start" menu-class="w-full max-w-lg">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 max-h-64 overflow-y-auto">

                <!-- Empty State. -->
                <div v-if="!query" class="text-gray-500 text-sm">
                    Start typing to search for known contact...
                </div>

                <div v-else class="space-y-6">
                    <div v-if="filteredDeliveryContactes.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Package Contacts</div>
                        <div class="space-y-1">
                            <button
                                v-for="deliveryContact in filteredDeliveryContactes"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="deliveryContact.name"
                                @click="selectContact(deliveryContact, close)"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full">{{ deliveryContact.name }}</div>
                                    <div class="truncate w-full text-xs text-gray-500" v-if="deliveryContact.phone">{{ deliveryContact.phone }}</div>
                                    <div class="truncate w-full text-xs text-gray-500" v-if="deliveryContact.phone2">{{ deliveryContact.phone2 }}</div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div v-else class="text-gray-500 text-sm">
                        No matching contacts found.
                    </div>

                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>
import {routePlanStore} from '@stores'

export default {
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
    },
    data() {
        return {
            query: '',
        }
    },
    computed: {
        $store() {
            return routePlanStore
        },
        filteredDeliveryContactes() {
            let dc = this.$store.state.deliveryContacts.filter(this.matchContact).slice(0, 100);
            this.$store.state.contacts.filter(this.matchContact).slice(0, 150).forEach((i) => {
                if (!dc.some((x) => i.name == x.name)) {
                    dc.push(i);
                }
            })
            return dc.sort((a, b) => {
                let score = 0;
                score += a.phone?0:1;
                score += b.phone?0:-1;
                return score;
            })
        },
    },
    methods: {
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        setQuery(query) {
            this.query = query
            if (!this.query) return
        },
        matchContact(deliveryContact) {
            const query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            let ret = query.every((token) => {
                return (deliveryContact.name+'|'+deliveryContact.phone+'|'+deliveryContact.phone2).toLowerCase().includes(token);
            });
            return ret;
        },
        selectContact(deliveryContact, close) {
            this.$emit('selected:deliveryContact', deliveryContact);
            this.query = deliveryContact.name+' '+deliveryContact.phone+' '+deliveryContact.phone2;
            close();
        },
    },
}
</script>
